export const orderStatus = {
  STATE_OPEN: 'Open',
  processing: 'Processing',
  pending: 'Pending',
  holded: 'On Hold',
  complete: 'Complete',
  canceled: 'Canceled',
  closed: 'Closed',
  fraud: 'Suspected Fraud',
  payment_review: 'Payment Review',
  pending_payment: 'Pending Payment',
  pending_paypal: 'Pending PayPal',
  paypal_reversed: 'PayPal Reversed',
  paypal_canceled_reversal: 'PayPal Canceled Reversal',
  dispute: 'In Dispute'
};

export const RequestAccessStatus = {
  'access_restricted': 'No Access',
  'no_access': 'No Access',
  'access_granted': 'Access Granted',
  'access_requested': 'Access Requested',
};

export const nextechIdTypes = {
  disabled: 'nextech_disabled,synced_before_cron',
  waitForSync: 'null, ',
  sync: 'nextech_disabled,synced_before_cron,null, ',
  error: ' '
};

export const modmedIdTypes = {
  disabled: 'modmed_disabled,synced_before_cron',
  waitForSync: 'null, ',
  sync: 'modmed_disabled,synced_before_cron,null, ',
  error: ' '
};

export const getIntegrationStatus = (order, integrationType) => {
  const { extension_attributes: integrations } = order;
  const integrationIds = integrations[`${integrationType}_id`];

  if (integrationIds) {
    const idsArray = integrationIds.split(',').map((id) => id.trim());
    const hasNumber = idsArray.some((id) => !isNaN(id));

    if (hasNumber) {
      return 'synced';
    } else if (idsArray.some((id) => id.includes('disabled')) || idsArray.includes('synced_before_cron')) {
      return 'disabled';
    }
  }

  if (integrations.emr_sync_error) {
    return 'error';
  }

  if (!integrationIds && !integrations.emr_sync_error) {
    return 'pending';
  }

  return '';
};

export const statusMessages = {
  synced: 'Synced',
  error: 'Not Synced',
  pending: 'Wait for sync',
  disabled: 'Disabled'
};

export const carriers = [
  {
    title: 'Custom',
    code: 'custom'
  },
  {
    title: 'ShipStation',
    code: 'shipstation'
  },
  {
    title: 'DHL',
    code: 'dhl'
  },
  {
    title: 'Federal Express',
    code: 'fedex'
  },
  {
    title: 'Magento Shipping',
    code: 'temando'
  },
  {
    title: 'United Parcel Service',
    code: 'ups'
  },
  {
    title: 'United States Postal Service',
    code: 'usps'
  },
  {
    title: 'BoxOut',
    code: 'boxout_shipping'
  }
];
